module.exports = __webpack_public_path__ + "dc10398a26440aea06f2a0779d1aa5b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/aboutLeads.png
// module id = 3250
// module chunks = 0